import React from 'react';
import { FilingTypeEnum, ReturnDisplayType } from '../../../utils/enums';
import LANGUAGE_CONTROLLER from '../../../controllers/languages';
import { checkFeatureFlagForReturnType } from '../../../utils/featureFlagMappingForReturnType';
import { SSelect } from '@avalara/skylab-sdk/react';

const EnableFiltersFor = [
    FilingTypeEnum.VATRETURN,
    FilingTypeEnum.INTRASTAT
];

const defaultFilterOptions = [
    ReturnDisplayType.SHOW_ALL,
    ReturnDisplayType.ONLY_NON_CORRECTIONS,
    ReturnDisplayType.CORRECTIONS_IN_THIS_PERIOD
];

const groupingFilterOptions = [
    ReturnDisplayType.SHOW_CORRECTIONS_GROUP_BY_PERIOD,
    ReturnDisplayType.SHOW_CORRECTIONS_GROUP_BY_PERIOD_INCLUDING_ORIGINAL_DOCUMENTS
];

const filterOptionsAsPerReturnType = (returnType, showGroupingOptions) => {
    let filterOptions = [];
    switch (returnType) {
        case FilingTypeEnum.VATRETURN:
        case FilingTypeEnum.VATBOOKS:
        case FilingTypeEnum.ECLISTING:
            filterOptions = (showGroupingOptions) ? defaultFilterOptions.concat(groupingFilterOptions) : defaultFilterOptions;
            break;
        case FilingTypeEnum.OSSIMPORT:
        case FilingTypeEnum.OSSNONUNION:
        case FilingTypeEnum.OSSUNION:
        case FilingTypeEnum.INTRASTAT:
            filterOptions = defaultFilterOptions;
            break;
        default:
            break;
    }
    return filterOptions;
}

const enableFilterAndCheckFeatureFlag = returnType => {
    const isFilterEnable = EnableFiltersFor.includes(returnType);
    switch (returnType) {
        case FilingTypeEnum.VATRETURN:
        case FilingTypeEnum.INTRASTAT:
            return isFilterEnable;
        case FilingTypeEnum.OSSIMPORT:
        case FilingTypeEnum.OSSNONUNION:
        case FilingTypeEnum.OSSUNION:
        case FilingTypeEnum.VATBOOKS:
        case FilingTypeEnum.ECLISTING:
            return checkFeatureFlagForReturnType(returnType);
        default:
            break;
    }
}

const TransactionFilter = (props) => {
    if(!(props.returnType && enableFilterAndCheckFeatureFlag(props.returnType))) {
        return <></>;
    }
    const filterOptions = filterOptionsAsPerReturnType(props.returnType, props.showGroupingOptions);

    return (
        <fieldset className="inline">
            <label className="mr5 uppercase">{LANGUAGE_CONTROLLER.format(props.languages, props.labelTextId)}:</label>
            <SSelect
                data-testid="transaction-filter-select"
                inputId="transaction-filter-select"
                name="transactionFilter"
                className="m4"
                onS-select={(e) => props.onSelect(e?.detail?.item?.value)}
                optionsList={filterOptions.map((filterOption) => ({
                    label: LANGUAGE_CONTROLLER.format(props.languages, filterOption.languageString),
                    value: `${filterOption.value}`,
                    selected: props.value === `${filterOption.value}`
                }))}
                multiple={false}
                showSelectionCount={false}
            />
        </fieldset>
    );
};


export default TransactionFilter;
